const TileSanction = ({ data = {}, t }) => {
  const toStr = (v) =>
    typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";
  const sanctionsTitle = toStr(data.sanctions_title);
  if (!sanctionsTitle) return null;

  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <div
        style={{
          position: "absolute",
          top: 8,
          bottom: 8,
          left: 0,
          width: 3,
          borderRadius: "0 3px 3px 0",
          background: t.warnAccent,
          transition: "opacity 0.2s",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          paddingLeft: 8,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: t.warnBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke={t.warnIcon}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
        <p
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: t.textPrimary,
            margin: 0,
            wordBreak: "break-word",
            lineHeight: 1.4,
          }}
        >
          {sanctionsTitle}
        </p>
      </div>
    </div>
  );
};

export default TileSanction;
